import { extractNumber, extractUnits } from "./units";

const frequencyFactors = {
  'nHz': 0.000000001,
  // 'µHz': 0.000001,
  'mHz': 0.001,
  'Hz': 1,
  'kHz': 1000,
  'MHz': 1000000,
  'GHz': 1000000000,
  'THz': 1000000000000,
}

export function convertToHz(str: string): number {
  const unit = extractUnits(str);
  const value = extractNumber(str);

  let factor = frequencyFactors[unit];

  if (unit === 'µHz') {
    factor = 0.000001;
  }

  return Math.floor(value * factor);
}

export function convertToKHz(str: string) {
  return convertToHz(str) / frequencyFactors.kHz;
}

export function convertToMHz(str: string) {
  return convertToHz(str) / frequencyFactors.MHz;
}

export function convertToGHz(str: string) {
  return convertToHz(str) / frequencyFactors.GHz;
}

export function convertToTHz(str: string) {
  return convertToHz(str) / frequencyFactors.THz;
}

export function convertHzIntoUnit(frequencyInHz: number, unit: string) {
  const stringFrequency = `${frequencyInHz} Hz`;
  switch (unit) {
    case 'kHz':
      return convertToKHz(stringFrequency);
    case 'MHz':
      return convertToMHz(stringFrequency);
    case 'GHz':
      return convertToGHz(stringFrequency);
    case 'THz':
      return convertToTHz(stringFrequency);
    default:
      return frequencyInHz;
  }
}